
const decimalDefVal='numberThree';

const defMesProConfigJsonLabel=[
  {label: '采购小数位数',type:'mesConfig', id: 'purchaseDecimalPlaces', active: false,defValue:decimalDefVal},
  {label: '销售小数位数', type:'mesConfig', id: 'salesDecimalPlaces', active: false,defValue:decimalDefVal},
  {label: '采购启用外币', type:'mesConfig', id: 'purchaseForeignCurrency', active: false,defValue:'false'},
  {label: '销售启用外币',type:'mesConfig',  id: 'salesForeignCurrency', active: false,defValue:'false'},
]

export default {
  salesForeignCurrency:'false',
  salesDecimalPlaces:decimalDefVal,
  purchaseForeignCurrency:'false',
  purchaseDecimalPlaces:decimalDefVal,
}

export {defMesProConfigJsonLabel};
